import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { GlitterHeart } from './GlitterHeart';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Courses',
    path: '/courses'
  }, {
    name: 'Coaching',
    path: '/coaching'
  }, {
    name: 'Travel',
    path: '/travel'
  }, {
    name: 'App',
    path: '/app'
  }];
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="flex justify-between items-center" data-id="element-136">
          {/* Logo */}
          <NavLink to="/" className="flex items-center gap-2 group" data-id="element-137">
            <GlitterHeart size={22} className="group-hover:scale-125 transition-transform" data-id="element-138" />
            <span className="font-heading text-lg md:text-2xl font-semibold text-plum-700 tracking-wide truncate max-w-[200px] md:max-w-none" data-id="element-139">
              <span className="md:hidden" data-id="element-140">Trippin' Through Life</span>
              <span className="hidden md:inline" data-id="element-141">Trippin' With Mandy</span>
            </span>
          </NavLink>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8" data-id="element-142">
            {navLinks.map(link => <NavLink key={link.name} to={link.path} className={({
            isActive
          }) => `font-medium text-sm transition-colors relative ${isActive ? 'text-plum-700' : 'text-plum-500 hover:text-plum-700'}`} data-id="element-143">
                {({
              isActive
            }) => <>
                    {link.name}
                    {isActive && <motion.div layoutId="underline" className="absolute -bottom-1 left-0 right-0 h-0.5 bg-cta-400 rounded-full" data-id="element-144" />}
                  </>}
              </NavLink>)}
            <NavLink to="/coaching" className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-cta-500 text-white font-medium text-sm hover:bg-cta-600 transition-colors shadow-md shadow-cta-500/20 whitespace-nowrap" data-id="element-145">
              <GlitterHeart size={16} variant="light" data-id="element-146" />
              Work With Me
            </NavLink>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-plum-700 focus:outline-none" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-147">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-148" /> : <MenuIcon className="w-6 h-6" data-id="element-149" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-150">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-blush-100 overflow-hidden" data-id="element-151">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-152">
              {navLinks.map(link => <NavLink key={link.name} to={link.path} className={({
            isActive
          }) => `block px-3 py-3 rounded-md text-base font-medium ${isActive ? 'bg-blush-50 text-plum-700' : 'text-plum-500 hover:bg-blush-50 hover:text-plum-700'}`} data-id="element-153">
                  {link.name}
                </NavLink>)}
              <NavLink to="/coaching" className="mt-4 flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-cta-500 text-white font-medium text-base hover:bg-cta-600 transition-colors" data-id="element-154">
                <GlitterHeart size={16} variant="light" data-id="element-155" />
                Work With Me
              </NavLink>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}